/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

export const OAUTH_KEYCHAIN_NAME = "com.mytolino.refresh_token";
export const OAUTH_DEFAULT_EXPIRE_SECONDS = 3600;
export const OAUTH_EXPIRE_THRESHOLD = 120 * 1000;
export const OAUTH_ERROR_CODES = Object.freeze({

  // -----------------------------------------------------------------------------
  // Internal status codes #todo: better status codes
  // -----------------------------------------------------------------------------

  0: {
    name: "OAUTH_USER_ABORTED",
    message: "User aborted request"
  },
  1: {
    name: "OAUTH_OFFLINE",
    message: "network is offline"
  },
  2: {
    name: "OAUTH_INTERNAL_CLIENT_ERROR",
    message: "¯\\_(ツ)_/¯"
  },
  3: {
    name: "OAUTH_INVALID_REFRESH_TOKEN",
    message: "invalid_refresh_token"
  },
  4: {
    name: "OAUTH_MISSING_PARAMETERS",
    message: "missing data for operation"
  },

  // -----------------------------------------------------------------------------
  // Official Status Codes
  // -----------------------------------------------------------------------------

  400: {
    name: "OAUTH_BAD_REQUEST",
    message: "invalid_request"
  },
  408: { //https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/408
    name: "OAUTH_TIMEOUT",
    message: "request timed out"
  },
  500: {
    name: "OAUTH_INTERNAL_SERVER_ERROR",
    message: "internal server error"
  }
});
